import React from 'react';
import { Briefcase } from 'lucide-react';
import PageMeta from '../components/PageMeta';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';

const Jobs = () => {
  return (
    <div className="jobs-page">
      <PageMeta
        title="Careers"
        description="Join BluekraftMed. Explore healthcare career opportunities for physicians, nurses, and allied health professionals."
        path="/jobs"
      />
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-cyan-600 to-blue-600 text-white py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <Briefcase className="w-20 h-20 mx-auto mb-6" />
            <h1 className="text-5xl font-bold mb-6">Career Opportunities</h1>
            <p className="text-xl leading-relaxed">
              Join the BluekraftMed team and advance your healthcare career
            </p>
          </div>
        </div>
      </section>

      {/* Jobs Content */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <Card className="shadow-xl">
              <CardHeader>
                <CardTitle className="text-3xl text-center">Explore Healthcare Opportunities</CardTitle>
              </CardHeader>
              <CardContent className="text-center">
                <p className="text-gray-600 text-lg mb-8 leading-relaxed">
                  We're always looking for talented healthcare professionals to join our network. Whether you're a physician, nurse, or allied health professional, we have exciting opportunities waiting for you.
                </p>
                <div className="space-y-4">
                  <div className="bg-cyan-50 p-6 rounded-lg">
                    <h3 className="text-xl font-semibold mb-2">Current Openings</h3>
                    <p className="text-gray-600">Check back soon for available positions</p>
                  </div>
                  <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
                    <Button className="bg-cyan-600 hover:bg-cyan-700 text-white px-8 py-6 text-lg">
                      Contact Us
                    </Button>
                    <Button className="bg-gray-200 hover:bg-gray-300 text-gray-800 px-8 py-6 text-lg">
                      Email: <a href='mailto:info@bluekraftmed.com' target="_blank">info@bluekraftmed.com</a>
                    </Button>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Jobs;